import { Component, Inject }              from '@angular/core';
import { MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService }               from '@ngx-translate/core';

@Component({
  selector      : 'YesNotDialog',
  templateUrl   : 'YesNotDialog.html',
})
export class YesNotDialog{

  custom_message = this._translateService.instant("generic.confirm_question");
  title          = this._translateService.instant("generic.notice");
  icon           = { "icon" : "help" , "style" : { 'color':'darkblue' } };

  constructor(
    private _translateService : TranslateService,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<YesNotDialog>)
  {
    this.title = data["title"] === undefined ? this._translateService.instant("generic.select_answer") : data["title"];

    if (data["custom_message"] !== undefined)
    {
      this.custom_message = data["custom_message"];
    }
    
    if (data["type"] !== undefined)
    {
      switch(data["type"])
      {
        case "warning"  : this.icon = { "icon" : "warning" , "style" : { 'color':'#FFA500' } }; break;
        case "error"    : this.icon = { "icon" : "error" , "style" : { 'color':'#990000' } }; break;
      }
    }

  }
  
  abort() : void {
    this.dialogRef.close(null);
  }

  yesClick(): void {
    this.dialogRef.close(true);
  }
  
  noClick(): void {
    this.dialogRef.close(false);
  }

}
